import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { LoadingService } from '../loading/loading.service';
import { Headers, Http } from "@angular/http";

@Injectable()
export class AliyunService {
  engineStatus: Observable<boolean>;
  private observer: Observer<boolean>;
  urlForBase64: string;
  result: any;
  urlForFile: string;
  aliyunUrlChange: any = new EventEmitter<any>();
  private urlStr: string = environment.aliyun.urlStr;
  /*private client = new OSS.Wrapper({
    // region: 'oss-cn-shanghai',
    // accessKeyId: 'LTAICadISGBAyskk',
    // accessKeySecret: 'TSnzCdIizqqW1QdW7VxbBJYStaMeZj',
    // bucket: environment.aliyun.bucket
    region: 'oss-cn-shanghai',
    accessKeyId: 'LTAIidH9g8dXh3vx',
    accessKeySecret: 'MtMXnEB5kQ3b54Jft84SA7cuLNeKTq',
    bucket: environment.aliyun.bucket
  });*/

  constructor(
    private loadingService: LoadingService,
    private http: Http,
  ) {
    this.engineStatus = new Observable<boolean>(observer => this.observer = observer).share();
  }

  guid() {
    const s4 = () =>
      Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
  };

  async getOssData(file: any, fileType:any) {
    this.http.get(environment.baseUrl + `oss/request-policy`, {}).subscribe((res: any) => {
      const result:any = JSON.parse(res._body);
      console.log(result,"-------getOssData");
      if (+result.code === 0) {
         this.uploadImgs(result.result, file, fileType)
      } else {
        swal('获取失败', result.message, 'warning')
      }
    });
  }

  randomString  (len: any)  {
    len = len || 32;
    const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    const maxPos = chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }

  async uploadImgs(results: any, file: any, fileType: any,) {
    console.log(fileType,"=========fileType")
    let formData: any = new FormData();
    let key=`${results.dir}${Date.now()}_${this.randomString(16)}.${fileType}`
    formData.append('key', `${key}`)
    formData.append('Signature', results.signature)
    formData.append('Policy', results.policy)
    formData.append('OSSAccessKeyId', results.accessid)
    formData.append('success_action_status', '200')
    formData.append('file', file)
      const httpOptions = {
          headers: new Headers({
              // 'Content-Type': `multipart/form-data; boundary=----`
          })
      };
      this.http.post(results.host, formData, httpOptions).subscribe((res: any) => {
          const url = `${results.host}/${key}`;
          this.loadingService.hide();
          this.urlForBase64 = url;
          this.urlForFile = url;
          this.aliyunUrlChange.emit(url);
          this.observer.next(true);
          console.info(url);
      }),(error: any) => {
          this.loadingService.hide();
          console.error(error);
            this.observer.next(false);
      }
  }
  uploadImageForFile(file: {},fileType: 'png',) {
    this.getOssData(file, fileType);
    // this.loadingService.show();
    // const storeAs = `avatar/${new Date().getTime()}-${this.guid()}.png`;
    //
    // this.client.multipartUpload(storeAs, img).then(result => {
    //   const url = `${this.urlStr}${result.name}`;
    //   this.loadingService.hide();
    //
    //   this.urlForFile = url;
    //   this.aliyunUrlChange.emit(url);
    //   this.observer.next(true);
    //   console.info(url);
    // }).catch(function (err) {
    //   this.loadingService.hide();
    //   console.error(err);
    //   this.observer.next(false);
    // });
  }

  uploadImageForBase64(img: string, type, cName) {
    this.loadingService.show();
    // 地址

    const dataURLtoFile: Function = (dataurl, filename) => {
      const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    };
    const file = dataURLtoFile(img, type);
     this.getOssData(file, type);
    /*const storeAs = `avatar/${new Date().getTime()}-${this.guid()}.${type}`;
    this.client.multipartUpload(storeAs, file).then(result => {
      const url = `${this.urlStr}${result.name}`;
      this.loadingService.hide();
      this.urlForBase64 = url;
      this.aliyunUrlChange.emit(url);
      this.observer.next(true);
      console.info(url);
    }).catch(err => {
      this.loadingService.hide();
      console.error(err);
      this.observer.next(false);
    });*/
  };

  getUrlForBase64() {
    return this.urlForBase64;
  }

  getUrlForFile() {
    return this.urlForFile;
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/aliyun/aliyun.service.ts